import { render, staticRenderFns } from "./BoxDetailsModal.vue?vue&type=template&id=33a20396"
import script from "./BoxDetailsModal.vue?vue&type=script&lang=js"
export * from "./BoxDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports